import domainConfig, {
    filtersUnrelatedToColumns,
} from 'app/PoC/DataGridDemoPages/ActivityRecordsDemo/ActivityRecordDemo.config'
import SkyNetMasterDataGrid from '../components/SkyNetMasterDataGrid'

const ActivityRecordsDemoPage = () => {
    return (
        <SkyNetMasterDataGrid
            config={domainConfig}
            filtersUnrelatedToColumns={filtersUnrelatedToColumns}
        />
    )
}

export default ActivityRecordsDemoPage
